module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_bg_bulgarian-0717abbc6df210a43c5d26cd34be00c4.svg";